import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { initializeTheme } from './hooks/use-appearance';
import { AuthStatusProvider } from './lib/auth-status';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

const formatDocumentTitle = (title?: string | null): string => {
    if (!title || !title.trim()) {
        return appName;
    }

    const normalizedTitle = title.trim();

    return normalizedTitle.endsWith(appName)
        ? normalizedTitle
        : `${normalizedTitle} - ${appName}`;
};

createInertiaApp({
    title: (title) => formatDocumentTitle(title),
    resolve: (name) =>
        resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob(['./pages/**/*.tsx', '!./pages/**/_archive/**']),
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <AuthStatusProvider>
                <App {...props} />
            </AuthStatusProvider>,
        );
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on load...
initializeTheme();
